import { PaymentStatus } from 'models'

export const PAYMENT_RECEIVE_STATUS = [
    PaymentStatus.Received,
    PaymentStatus.Authorised,
    PaymentStatus.PaidOnAccount,
]
export const RETURN_PAYMENT_STATUS = [PaymentStatus.Returned]
